import React from 'react';
export const Footer = () => {
  return <footer className="bg-black border-t border-white/10 py-12" data-id="element-133">
      <div className="container mx-auto px-4" data-id="element-134">
        <div className="grid md:grid-cols-4 gap-8" data-id="element-135">
          <div data-id="element-136">
            <h3 className="font-orbitron text-lg tracking-wider mb-6" data-id="element-137">
              <span className="text-white" data-id="element-138">LEX</span>
              <span className="text-zinc-400" data-id="element-139">SQUIRE</span>
            </h3>
            <p className="text-zinc-400 text-sm font-light" data-id="element-140">
              We bring AI to your human legal services.
            </p>
          </div>
          <div data-id="element-141">
            <h4 className="text-white mb-4" data-id="element-142">Platform</h4>
            <ul className="space-y-2 text-zinc-400 text-sm" data-id="element-143">
              <li data-id="element-144">
                <a href="/features" className="hover:text-white transition-colors" data-id="element-145">
                  Features
                </a>
              </li>
              <li data-id="element-146">
                <a href="/integrations" className="hover:text-white transition-colors" data-id="element-147">
                  Integrations
                </a>
              </li>
              <li data-id="element-148">
                <a href="/pricing" className="hover:text-white transition-colors" data-id="element-149">
                  Pricing
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-150">
            <h4 className="text-white mb-4" data-id="element-151">Resources</h4>
            <ul className="space-y-2 text-zinc-400 text-sm" data-id="element-152">
              <li data-id="element-153">
                <a href="https://messagesimproved-c95820de.mintlify.app/guide/introduction" className="hover:text-white transition-colors" data-id="element-154">
                  API
                </a>
              </li>
              <li data-id="element-155">
                <a href="mailto:support@lexsquire.legal" className="hover:text-white transition-colors" data-id="element-156">
                  Support
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-157">
            <h4 className="text-white mb-4" data-id="element-158">Company</h4>
            <ul className="space-y-2 text-zinc-400 text-sm" data-id="element-159">
              <li data-id="element-160">
                <a href="/vision" className="hover:text-white transition-colors" data-id="element-161">
                  About
                </a>
              </li>
              <li data-id="element-162">
                <a href="mailto:info@lexsquire.legal" className="hover:text-white transition-colors" data-id="element-163">
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>;
};